<script>
  import { onMount, onDestroy } from "svelte";
  import { createEventDispatcher } from "svelte";
  import { api, apiOutside } from "../../utilities/Utils.svelte";
  import { bind } from "svelte/internal";

  export let src;

  const dispatch = createEventDispatcher();

  onMount(() => {
    loadImage();
  });

  let imgContainer;
  let loaded = false;
  let error = false;
  let retries = 0;
  const maxRetries = 3;

  function loadImage() {
    dispatch("imageInit", { src });
    imgContainer.src = src;
  }

  function imageLoaded() {
      console.log("Image loaded successfully:", src);
      loaded = true;
      error = false;
      dispatch("imageLoaded", { src });
    }

  function imageError(event) {
      retries += 1;
      if (retries <= maxRetries) {
        console.error(
          `Image failed to load, retrying (${retries}/${maxRetries}):`,
          src
        );
        setTimeout(loadImage, 500); // retry after 500ms
      } else {
        console.error(
          `Image failed to load after ${maxRetries} retries:`,
          src
        );
        error = true;
        dispatch("imageError", {
          src,
          message: `Failed to load image after ${maxRetries} retries.`,
        });
      }
    }
</script>

<img class:loading={!loaded} bind:this={imgContainer} on:load={imageLoaded} on:error={imageError} class="customImage"
   {src} alt="" />

{#if loaded}
{:else if error}
  <div>Failed to load image after {maxRetries} retries.</div>
{:else}
  <div>Loading...</div>
{/if}

<style>

  .loading{
    display: none;
  }
  @media (min-width: 768px) {
    .customImage {
      max-width: 600px;
      max-height: 600px;
    }
  }

  @media (max-width: 768px) {
    .customImage {
      max-width: 100%;
    }
  }
</style>
